function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import { DateTime as t } from "@easepick/datetime";
import { BasePlugin as e } from "@easepick/base-plugin";

var i = /*#__PURE__*/function (_e) {
  _inherits(i, _e);

  var _super = _createSuper(i);

  function i() {
    var _this;

    _classCallCheck(this, i);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    _this.tooltipElement = void 0;
    _this.triggerElement = void 0;
    _this.binds = {
      setStartDate: _this.setStartDate.bind(_assertThisInitialized(_this)),
      setEndDate: _this.setEndDate.bind(_assertThisInitialized(_this)),
      setDateRange: _this.setDateRange.bind(_assertThisInitialized(_this)),
      getStartDate: _this.getStartDate.bind(_assertThisInitialized(_this)),
      getEndDate: _this.getEndDate.bind(_assertThisInitialized(_this)),
      onView: _this.onView.bind(_assertThisInitialized(_this)),
      onShow: _this.onShow.bind(_assertThisInitialized(_this)),
      onMouseEnter: _this.onMouseEnter.bind(_assertThisInitialized(_this)),
      onMouseLeave: _this.onMouseLeave.bind(_assertThisInitialized(_this)),
      onClickCalendarDay: _this.onClickCalendarDay.bind(_assertThisInitialized(_this)),
      onClickApplyButton: _this.onClickApplyButton.bind(_assertThisInitialized(_this)),
      parseValues: _this.parseValues.bind(_assertThisInitialized(_this)),
      updateValues: _this.updateValues.bind(_assertThisInitialized(_this)),
      clear: _this.clear.bind(_assertThisInitialized(_this))
    };
    _this.options = {
      elementEnd: null,
      startDate: null,
      endDate: null,
      repick: !1,
      strict: !0,
      delimiter: " - ",
      tooltip: !0,
      tooltipNumber: function tooltipNumber(t) {
        return t;
      },
      locale: {
        zero: "",
        one: "day",
        two: "",
        few: "",
        many: "",
        other: "days"
      },
      documentClick: _this.hidePicker.bind(_assertThisInitialized(_this))
    };
    return _this;
  }

  _createClass(i, [{
    key: "getName",
    value: function getName() {
      return "RangePlugin";
    }
  }, {
    key: "onAttach",
    value: function onAttach() {
      this.binds._setStartDate = this.picker.setStartDate, this.binds._setEndDate = this.picker.setEndDate, this.binds._setDateRange = this.picker.setDateRange, this.binds._getStartDate = this.picker.getStartDate, this.binds._getEndDate = this.picker.getEndDate, this.binds._parseValues = this.picker.parseValues, this.binds._updateValues = this.picker.updateValues, this.binds._clear = this.picker.clear, this.binds._onClickCalendarDay = this.picker.onClickCalendarDay, this.binds._onClickApplyButton = this.picker.onClickApplyButton, Object.defineProperties(this.picker, {
        setStartDate: {
          configurable: !0,
          value: this.binds.setStartDate
        },
        setEndDate: {
          configurable: !0,
          value: this.binds.setEndDate
        },
        setDateRange: {
          configurable: !0,
          value: this.binds.setDateRange
        },
        getStartDate: {
          configurable: !0,
          value: this.binds.getStartDate
        },
        getEndDate: {
          configurable: !0,
          value: this.binds.getEndDate
        },
        parseValues: {
          configurable: !0,
          value: this.binds.parseValues
        },
        updateValues: {
          configurable: !0,
          value: this.binds.updateValues
        },
        clear: {
          configurable: !0,
          value: this.binds.clear
        },
        onClickCalendarDay: {
          configurable: !0,
          value: this.binds.onClickCalendarDay
        },
        onClickApplyButton: {
          configurable: !0,
          value: this.binds.onClickApplyButton
        }
      }), this.options.elementEnd && (this.options.elementEnd instanceof HTMLElement || (this.options.elementEnd = this.picker.options.doc.querySelector(this.options.elementEnd)), this.options.elementEnd instanceof HTMLInputElement && (this.options.elementEnd.readOnly = this.picker.options.readonly), "function" == typeof this.picker.options.documentClick && (document.removeEventListener("click", this.picker.options.documentClick, !0), "function" == typeof this.options.documentClick && document.addEventListener("click", this.options.documentClick, !0)), this.options.elementEnd.addEventListener("click", this.picker.show.bind(this.picker))), this.options.repick = this.options.repick && this.options.elementEnd instanceof HTMLElement, this.picker.options.date = null, this.picker.on("view", this.binds.onView), this.picker.on("show", this.binds.onShow), this.picker.on("mouseenter", this.binds.onMouseEnter, !0), this.picker.on("mouseleave", this.binds.onMouseLeave, !0), this.checkIntlPluralLocales();
    }
  }, {
    key: "onDetach",
    value: function onDetach() {
      Object.defineProperties(this.picker, {
        setStartDate: {
          configurable: !0,
          value: this.binds._setStartDate
        },
        setEndDate: {
          configurable: !0,
          value: this.binds._setEndDate
        },
        setDateRange: {
          configurable: !0,
          value: this.binds._setDateRange
        },
        getStartDate: {
          configurable: !0,
          value: this.binds._getStartDate
        },
        getEndDate: {
          configurable: !0,
          value: this.binds._getEndDate
        },
        parseValues: {
          configurable: !0,
          value: this.binds._parseValues
        },
        updateValues: {
          configurable: !0,
          value: this.binds._updateValues
        },
        clear: {
          configurable: !0,
          value: this.binds._clear
        },
        onClickCalendarDay: {
          configurable: !0,
          value: this.binds._onClickCalendarDay
        },
        onClickApplyButton: {
          configurable: !0,
          value: this.binds._onClickApplyButton
        }
      }), this.picker.off("view", this.binds.onView), this.picker.off("show", this.binds.onShow), this.picker.off("mouseenter", this.binds.onMouseEnter, !0), this.picker.off("mouseleave", this.binds.onMouseLeave, !0);
    }
  }, {
    key: "parseValues",
    value: function parseValues() {
      if (this.options.startDate || this.options.endDate) this.options.strict ? this.options.startDate && this.options.endDate ? this.setDateRange(this.options.startDate, this.options.endDate) : (this.options.startDate = null, this.options.endDate = null) : (this.options.startDate && this.setStartDate(this.options.startDate), this.options.endDate && this.setEndDate(this.options.endDate));else if (this.options.elementEnd) this.options.strict ? this.picker.options.element instanceof HTMLInputElement && this.picker.options.element.value.length && this.options.elementEnd instanceof HTMLInputElement && this.options.elementEnd.value.length && this.setDateRange(this.picker.options.element.value, this.options.elementEnd.value) : (this.picker.options.element instanceof HTMLInputElement && this.picker.options.element.value.length && this.setStartDate(this.picker.options.element.value), this.options.elementEnd instanceof HTMLInputElement && this.options.elementEnd.value.length && this.setEndDate(this.options.elementEnd.value));else if (this.picker.options.element instanceof HTMLInputElement && this.picker.options.element.value.length) {
        var _this$picker$options$ = this.picker.options.element.value.split(this.options.delimiter),
            _this$picker$options$2 = _slicedToArray(_this$picker$options$, 2),
            _t = _this$picker$options$2[0],
            _e2 = _this$picker$options$2[1];

        this.options.strict ? _t && _e2 && this.setDateRange(_t, _e2) : (_t && this.setStartDate(_t), _e2 && this.setEndDate(_e2));
      }
    }
  }, {
    key: "updateValues",
    value: function updateValues() {
      var t = this.picker.options.element,
          e = this.options.elementEnd,
          _i = this.picker.getStartDate(),
          s = this.picker.getEndDate(),
          n = _i instanceof Date ? _i.format(this.picker.options.format, this.picker.options.lang) : "",
          a = s instanceof Date ? s.format(this.picker.options.format, this.picker.options.lang) : "";

      if (e) t instanceof HTMLInputElement ? t.value = n : t instanceof HTMLElement && (t.innerText = n), e instanceof HTMLInputElement ? e.value = a : e instanceof HTMLElement && (e.innerText = a);else {
        var _e3 = "".concat(n).concat(n || a ? this.options.delimiter : "").concat(a);

        t instanceof HTMLInputElement ? t.value = _e3 : t instanceof HTMLElement && (t.innerText = _e3);
      }
    }
  }, {
    key: "clear",
    value: function clear() {
      this.options.startDate = null, this.options.endDate = null, this.picker.datePicked.length = 0, this.updateValues(), this.picker.renderAll(), this.picker.trigger("clear");
    }
  }, {
    key: "onShow",
    value: function onShow(t) {
      var e = t.detail.target;
      this.triggerElement = e, this.picker.options.scrollToDate && this.getStartDate() instanceof Date && this.picker.gotoDate(this.getStartDate()), this.initializeRepick();
    }
  }, {
    key: "onView",
    value: function onView(e) {
      var _e$detail = e.detail,
          _i2 = _e$detail.view,
          s = _e$detail.target;

      if ("Main" === _i2 && (this.tooltipElement = document.createElement("span"), this.tooltipElement.className = "range-plugin-tooltip", s.appendChild(this.tooltipElement)), "CalendarDay" === _i2) {
        var _e4 = new t(s.dataset.time),
            _i13 = this.picker.datePicked,
            n = _i13.length ? this.picker.datePicked[0] : this.getStartDate(),
            a = _i13.length ? this.picker.datePicked[1] : this.getEndDate();

        n && n.isSame(_e4, "day") && s.classList.add("start"), n && a && (a.isSame(_e4, "day") && s.classList.add("end"), _e4.isBetween(n, a) && s.classList.add("in-range"));
      }

      if ("Footer" === _i2) {
        var _t2 = 1 === this.picker.datePicked.length && !this.options.strict || 2 === this.picker.datePicked.length;

        s.querySelector(".apply-button").disabled = !_t2;
      }
    }
  }, {
    key: "hidePicker",
    value: function hidePicker(t) {
      var e = t.target,
          _i4 = null;
      e.shadowRoot && (e = t.composedPath()[0], _i4 = e.getRootNode().host), this.picker.isShown() && _i4 !== this.picker.ui.wrapper && e !== this.picker.options.element && e !== this.options.elementEnd && this.picker.hide();
    }
  }, {
    key: "setStartDate",
    value: function setStartDate(e) {
      var _i5 = new t(e, this.picker.options.format);

      this.options.startDate = _i5 ? _i5.clone() : null, this.updateValues(), this.picker.renderAll();
    }
  }, {
    key: "setEndDate",
    value: function setEndDate(e) {
      var _i6 = new t(e, this.picker.options.format);

      this.options.endDate = _i6 ? _i6.clone() : null, this.updateValues(), this.picker.renderAll();
    }
  }, {
    key: "setDateRange",
    value: function setDateRange(e, _i7) {
      var s = new t(e, this.picker.options.format),
          n = new t(_i7, this.picker.options.format);
      this.options.startDate = s ? s.clone() : null, this.options.endDate = n ? n.clone() : null, this.updateValues(), this.picker.renderAll();
    }
  }, {
    key: "getStartDate",
    value: function getStartDate() {
      return this.options.startDate instanceof Date ? this.options.startDate.clone() : null;
    }
  }, {
    key: "getEndDate",
    value: function getEndDate() {
      return this.options.endDate instanceof Date ? this.options.endDate.clone() : null;
    }
  }, {
    key: "onMouseEnter",
    value: function onMouseEnter(e) {
      var _this2 = this;

      var _i8 = e.target;

      if (_i8 instanceof HTMLElement) {
        this.isContainer(_i8) && this.initializeRepick();

        var _e5 = _i8.closest(".unit");

        if (!(_e5 instanceof HTMLElement)) return;

        if (this.picker.isCalendarDay(_e5)) {
          if (1 !== this.picker.datePicked.length) return;

          var _i14 = this.picker.datePicked[0].clone(),
              s = new t(_e5.dataset.time),
              n = !1;

          if (_i14.isAfter(s, "day")) {
            var _t3 = _i14.clone();

            _i14 = s.clone(), s = _t3.clone(), n = !0;
          }

          if (_toConsumableArray(this.picker.ui.container.querySelectorAll(".day")).forEach(function (a) {
            var o = new t(a.dataset.time),
                l = _this2.picker.Calendar.getCalendarDayView(o);

            o.isBetween(_i14, s) && l.classList.add("in-range"), o.isSame(_this2.picker.datePicked[0], "day") && (l.classList.add("start"), l.classList.toggle("flipped", n)), a === _e5 && (l.classList.add("end"), l.classList.toggle("flipped", n)), a.className = l.className;
          }), this.options.tooltip) {
            var _t4 = this.options.tooltipNumber(s.diff(_i14, "day") + 1);

            if (_t4 > 0) {
              var _i15 = new Intl.PluralRules(this.picker.options.lang).select(_t4),
                  _s2 = "".concat(_t4, " ").concat(this.options.locale[_i15]);

              this.showTooltip(_e5, _s2);
            } else this.hideTooltip();
          }
        }
      }
    }
  }, {
    key: "onMouseLeave",
    value: function onMouseLeave(t) {
      if (this.isContainer(t.target) && this.options.repick) {
        var _t5 = this.getStartDate(),
            _e6 = this.getEndDate();

        _t5 && _e6 && (this.picker.datePicked.length = 0, this.picker.renderAll());
      }
    }
  }, {
    key: "onClickCalendarDay",
    value: function onClickCalendarDay(e) {
      if (this.picker.isCalendarDay(e)) {
        2 === this.picker.datePicked.length && (this.picker.datePicked.length = 0);

        var _i16 = new t(e.dataset.time);

        if (this.picker.datePicked[this.picker.datePicked.length] = _i16, 2 === this.picker.datePicked.length && this.picker.datePicked[0].isAfter(this.picker.datePicked[1])) {
          var _t6 = this.picker.datePicked[1].clone();

          this.picker.datePicked[1] = this.picker.datePicked[0].clone(), this.picker.datePicked[0] = _t6.clone();
        }

        1 !== this.picker.datePicked.length && this.picker.options.autoApply || this.picker.trigger("preselect", {
          start: this.picker.datePicked[0] instanceof Date ? this.picker.datePicked[0].clone() : null,
          end: this.picker.datePicked[1] instanceof Date ? this.picker.datePicked[1].clone() : null
        }), 1 === this.picker.datePicked.length && (!this.options.strict && this.picker.options.autoApply && (this.picker.options.element === this.triggerElement && this.setStartDate(this.picker.datePicked[0]), this.options.elementEnd === this.triggerElement && this.setEndDate(this.picker.datePicked[0]), this.picker.trigger("select", {
          start: this.picker.getStartDate(),
          end: this.picker.getEndDate()
        })), this.picker.renderAll()), 2 === this.picker.datePicked.length && (this.picker.options.autoApply ? (this.setDateRange(this.picker.datePicked[0], this.picker.datePicked[1]), this.picker.trigger("select", {
          start: this.picker.getStartDate(),
          end: this.picker.getEndDate()
        }), this.picker.hide()) : (this.hideTooltip(), this.picker.renderAll()));
      }
    }
  }, {
    key: "onClickApplyButton",
    value: function onClickApplyButton(t) {
      this.picker.isApplyButton(t) && (1 !== this.picker.datePicked.length || this.options.strict || (this.picker.options.element === this.triggerElement && (this.options.endDate = null, this.setStartDate(this.picker.datePicked[0])), this.options.elementEnd === this.triggerElement && (this.options.startDate = null, this.setEndDate(this.picker.datePicked[0]))), 2 === this.picker.datePicked.length && this.setDateRange(this.picker.datePicked[0], this.picker.datePicked[1]), this.picker.trigger("select", {
        start: this.picker.getStartDate(),
        end: this.picker.getEndDate()
      }), this.picker.hide());
    }
  }, {
    key: "showTooltip",
    value: function showTooltip(t, e) {
      this.tooltipElement.style.visibility = "visible", this.tooltipElement.innerHTML = e;

      var _i12 = this.picker.ui.container.getBoundingClientRect(),
          s = this.tooltipElement.getBoundingClientRect(),
          n = t.getBoundingClientRect();

      var a = n.top,
          o = n.left;
      a -= _i12.top, o -= _i12.left, a -= s.height, o -= s.width / 2, o += n.width / 2, this.tooltipElement.style.top = "".concat(a, "px"), this.tooltipElement.style.left = "".concat(o, "px");
    }
  }, {
    key: "hideTooltip",
    value: function hideTooltip() {
      this.tooltipElement.style.visibility = "hidden";
    }
  }, {
    key: "checkIntlPluralLocales",
    value: function checkIntlPluralLocales() {
      if (!this.options.tooltip) return;

      var t = _toConsumableArray(new Set([new Intl.PluralRules(this.picker.options.lang).select(0), new Intl.PluralRules(this.picker.options.lang).select(1), new Intl.PluralRules(this.picker.options.lang).select(2), new Intl.PluralRules(this.picker.options.lang).select(6), new Intl.PluralRules(this.picker.options.lang).select(18)])),
          e = Object.keys(this.options.locale);

      t.every(function (t) {
        return e.includes(t);
      }) || console.warn("".concat(this.getName(), ": provide locales (").concat(t.join(", "), ") for correct tooltip text."));
    }
  }, {
    key: "initializeRepick",
    value: function initializeRepick() {
      if (!this.options.repick) return;
      var t = this.getStartDate(),
          e = this.getEndDate();
      e && this.triggerElement === this.picker.options.element && (this.picker.datePicked[0] = e), t && this.triggerElement === this.options.elementEnd && (this.picker.datePicked[0] = t);
    }
  }, {
    key: "isContainer",
    value: function isContainer(t) {
      return t === this.picker.ui.container;
    }
  }]);

  return i;
}(e);

export { i as RangePlugin };